import { render, staticRenderFns } from "./EtiquetaNuevoEditar.vue?vue&type=template&id=6d09465f&"
import script from "./EtiquetaNuevoEditar.vue?vue&type=script&lang=js&"
export * from "./EtiquetaNuevoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports